import $ from 'jquery';
import toast from 'react-hot-toast'




//الارم برای خالی رها نشدن فیلد ها
export function validateForm(e) {



  var isValid = true;
  $($(e.currentTarget).find("Input")).each(function (index, element) {
    var isValidInput = $(element).attr("requiredir") === "true";
    // var isValidInput = $(element).attr("required") == "true";

    //اگر ریکوایرد تورو باشد و خالی باشد پیغام ظاهر میشود
    if (isValidInput) {
      if ($(this).val() === "" || $(this).val() === null) {
        isValid = false;
        toast.error(`${$(element).attr("placeholder")} را پر کنید`);
      }
    }
  });
  return isValid;
}










